<template>
  <div
    class="general-frame"
    style="width: 100%; height: 100%; position: absolute; bottom: 0; top: 0"
  >
    <div style="height: 7%" class="homePages">
      <top style="height: 100%" />
    </div>
    <div style="background: rgb(0, 0, 0); height: 88%">
      <div style="height: 97.5%; padding: 0.5%" class="flex">
        <div
          style="
            width: 24%;
            height: 100%;
            flex-direction: column;
            display: flex;
            justify-content: space-between;
          "
        >
          <div style="height: 40%" class="frame">
            <div style="text-align: left; height: 20%">
              <div class="title">厕所分类统计</div>
              <span class="english">Toilet classification statistics</span>
            </div>
            <div
              style="
                width: 100%;
                min-height: 65%;
                clear: both;
                box-sizing: border-box;
                height: 80%;
              "
              class="flex"
            >
              <div style="width: 30%; height: 100%" class="flexcz">
                <div style="height: 20%; width: 100%">
                  <span class="flex-center kg100 boxsize">
                    <span class="home-title-view"> 智慧厕所</span>
                  </span>
                </div>
                <div class="wisdomNum" @click="enterNum(1)">
                  <iconEffect
                    :toiletNum="[0, toiletTypeStatistics.wisdomNum]"
                  ></iconEffect>
                </div>
                <el-dialog
                  style="font-size: 1.3vw"
                  :title="
                    time2 == 1
                      ? '智慧厕所'
                      : time2 == 2
                      ? '真空厕所'
                      : '传统厕所'
                  "
                  :visible.sync="dialogVisible1"
                  width="20%"
                  @close="eleaveNum"
                >
                  <span
                    style="font-size: 0.9vw"
                    v-for="(item, index) in time2 == 1
                      ? wisdomNums
                      : time2 == 2
                      ? vacuumNums
                      : transtions"
                    :key="index"
                    >{{ item.name }}<br
                  /></span>
                </el-dialog>
                <div class="bordertop flexcz home-title">
                  <div style="height: 20%; width: 100%">
                    <span
                      class="flex-start kg100 boxsize"
                      style="padding: 0 5px"
                    >
                      <span style="text-align: left">
                        运维：<span class="home-title-view"
                          >{{ toiletTypeStatistics.wisdomOrderNum }}次</span
                        >
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div style="width: 30%; height: 100%" class="flexcz">
                <div style="height: 20%; width: 100%">
                  <span class="flex-center kg100 boxsize">
                    <span class="home-title-view"> 真空厕所</span>
                  </span>
                </div>
                <div class="vacuumNum" @click="enterNum(2)">
                  <iconEffect
                    :toiletNum="[1, toiletTypeStatistics.vacuumNum]"
                  ></iconEffect>
                </div>
                <div class="bordertop flexcz home-title">
                  <div style="height: 40%; width: 100%">
                    <span
                      class="flex-center kg100 boxsize"
                      style="padding: 0 5px"
                    >
                      <span>
                        运维：<span class="home-title-view"
                          >{{ toiletTypeStatistics.vacuumOrderNum }}次</span
                        >
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div style="width: 30%; height: 100%" class="flexcz">
                <div style="height: 20%; width: 100%">
                  <span class="flex-center kg100 boxsize">
                    <span class="home-title-view"> 传统厕所</span>
                  </span>
                </div>
                <div class="tradition" @click="enterNum(3)">
                  <iconEffect :toiletNum="[2, transtions.length]"></iconEffect>
                </div>
                <div class="bordertop flexcz home-title">
                  <div style="height: 40%; width: 100%">
                    <span
                      class="flex-center kg100 boxsize"
                      style="padding: 0 5px"
                    >
                      <span style="text-align: left">
                        运维：<span class="home-title-view">无</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style="
              height: calc(60% - 8px);
              margin-top: 8px;
              width: 100%;
              padding: 1%;
            "
            class="frame boxsize"
          >
            <div class="flex" style="text-align: left; height: 15%">
              <div style="width: 32%">
                <div class="title">空气质量分析</div>
                <span class="english">Air quality</span>
              </div>
              <div
                class="flex-center;"
                style="width: 68%; height: 100%; overflow: hidden"
              >
                <div style="width: 100%; height: 10%"></div>
                <el-tabs
                  type="border-card"
                  @tab-click="changePage"
                  v-model="editableTabsValue"
                >
                  <el-tab-pane
                    v-for="(item, index) in wisdomNums"
                    :label="item.name"
                    :key="index"
                  ></el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div style="height: 85%; width: 100%">
              <el-carousel
                ref="carousel"
                arrow="never"
                :interval="8000"
                indicator-position="none"
                height="39.5vh"
                @change="carouselChange"
              >
                <el-carousel-item
                  class="kg100"
                  v-for="(item, index) in wisdomNums"
                  :key="index"
                >
                  <div class="kg100 flexcz">
                    <el-row class="row-air">
                      <el-col
                        :span="12"
                        class="air-col-8 bordertop boxsize"
                        style="margin-right: 10px; margin-bottom: 5px"
                      >
                        <div
                          class="positiontop flex"
                          style="bottom: 5%; left: -7%"
                        >
                          <img src="../../img/tiles/wd.svg" alt="" />
                          <p style="margin-left: -30%">温度</p>
                        </div>
                        <div class="titleIng">
                          <div style="margin-left: 5%">
                            <p>
                              男：
                              <span class="title_color"
                                >{{ toiletAir[index].temp }}
                                <span>℃</span></span
                              >
                            </p>
                            <p>
                              女：
                              <span class="title_color"
                                >{{ toiletAir[index + 1].temp
                                }}<span>℃</span></span
                              >
                            </p>
                          </div>
                        </div>
                      </el-col>
                      <el-col
                        :span="12"
                        class="air-col-8 bordertop boxsize"
                        style="margin-left: 10px; margin-bottom: 5px"
                      >
                        <div
                          class="positiontop flex"
                          style="bottom: 3%; right: 2.5%"
                        >
                          <p style="white-space: nowrap">湿度</p>
                          <img src="../../img/tiles/sd.svg" alt="" />
                        </div>
                        <div class="titleIng" style="margin-right: 5%">
                          <div style="float: right">
                            <p>
                              <span class="title_color"
                                >{{ toiletAir[index].hum
                                }}<span style="font-family: '微软正黑体'"
                                  >%</span
                                ><span>RH </span></span
                              >
                              :男
                            </p>
                            <p>
                              <span class="title_color"
                                >{{ toiletAir[index + 1].hum
                                }}<span style="font-family: '微软正黑体'"
                                  >%</span
                                ><span>RH </span></span
                              >
                              :女
                            </p>
                          </div>
                        </div>
                      </el-col>
                    </el-row>

                    <el-row class="row-air">
                      <div class="kg100">
                        <el-col
                          :span="12"
                          class="air-col-8 bordertop boxsize"
                          style="margin-right: 10px; margin-top: 5px"
                        >
                          <div
                            class="positiontop flex"
                            style="top: 2%; left: 2%"
                          >
                            <img
                              src="../../img/tiles/aq.svg"
                              style="width: 2.5vw; height: 2.5vw; margin: 5px"
                              alt=""
                            />
                            <p>氨气</p>
                          </div>
                          <div
                            class="titleIng positiontop"
                            style="bottom: 3%; left: 2%; margin-left: 5%"
                          >
                            <div>
                              <p>
                                男：
                                <span class="title_color"
                                  >{{ toiletAir[index].nh3
                                  }}<span> ppm</span></span
                                >
                              </p>
                              <p>
                                女：
                                <span class="title_color"
                                  >{{ toiletAir[index + 1].nh3
                                  }}<span> ppm</span></span
                                >
                              </p>
                            </div>
                          </div>
                        </el-col>
                        <el-col
                          :span="12"
                          class="air-col-8 bordertop boxsize"
                          style="margin-left: 10px; margin-top: 5px"
                        >
                          <div
                            class="positiontop flex"
                            style="top: 0; right: -1%"
                          >
                            <p style="">硫化氢</p>
                            <img
                              src="../../img/tiles/lhy.svg"
                              style="width: 3vw; height: 2.5vw; margin: 5px"
                              alt=""
                            />
                          </div>

                          <div
                            class="titleIng positiontop"
                            style="bottom: 3%; right: 2%; margin-right: 5%"
                          >
                            <div style="float: right">
                              <p>
                                <span class="title_color"
                                  >{{ toiletAir[index].h2s
                                  }}<span> ppm</span></span
                                >
                                :男
                              </p>
                              <p>
                                <span class="title_color"
                                  >{{ toiletAir[index + 1].h2s
                                  }}<span> ppm</span></span
                                >
                                :女
                              </p>
                            </div>
                          </div>
                        </el-col>
                      </div>
                    </el-row>
                    <div class="position air-ball"></div>
                    <div class="position air-ball0"></div>
                    <div class="position air-ball1">
                      <ul class="flexcz kg100" style="padding: 0; margin: 0">
                        <li
                          class="flex-center"
                          style="height: 30%; width: 100%; font-size: 1.2vw"
                        >
                          <span>
                            男：<span
                              :class="{
                                airA: toiletAir[index].evaluateLevel == 1,
                                airB: toiletAir[index].evaluateLevel == 2,
                                airC: toiletAir[index].evaluateLevel == 3
                              }"
                              >{{
                                toiletAir[index].evaluateLevel == 1
                                  ? "优"
                                  : toiletAir[index].evaluateLevel == 2
                                  ? "良"
                                  : "差"
                              }}</span
                            ></span
                          >
                        </li>
                        <li class="flexcz" style="width: 100%">
                          <span style="font-size: 1.5vw; font-family: '黑体'">
                            {{ item.name }} </span
                          ><span
                            style="font-size: 0.6vw; font-family: '华文细黑'"
                            >室内空气质量</span
                          >
                        </li>

                        <li
                          class="flex-center"
                          style="height: 30%; width: 100%; font-size: 1.2vw"
                        >
                          <span>
                            女：<span
                              :class="{
                                airA: toiletAir[index + 1].evaluateLevel == 1,
                                airB: toiletAir[index + 1].evaluateLevel == 2,
                                airC: toiletAir[index + 1].evaluateLevel == 3
                              }"
                              >{{
                                toiletAir[index + 1].evaluateLevel == 1
                                  ? "优"
                                  : toiletAir[index + 1].evaluateLevel == 2
                                  ? "良"
                                  : "差"
                              }}</span
                            ></span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <div
          style="
            width: 49.7%;
            height: 100%;
            flex-direction: column;
            display: flex;
            justify-content: space-between;
          "
        >
          <div class="flex-center" style="height: 72%;text-align: center">
            <dv-border-box-1 :color="['#032CF2', '#fff']">
              <div
                class="kg100"
                style="box-sizing:border-box; padding:30px 25px;"
              >
                <tow-map :isScreen="true"></tow-map>
              </div>
            </dv-border-box-1>

            <!-- 厕所详情 -->
          </div>
          <div style="height: 23.3%; padding: 1%" class="frame flex">
            <div
              class="flexcz k_b1 the_boxshadow"
              style="width: 30%; height: 100%; padding: 1%"
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <div style="text-align: left; padding-bottom: 5px; height: 25%">
                <div class="title">真空厕所能耗</div>
                <span class="english">Vacuum toilet</span>
              </div>
              <div class="flex-center" style="height: 75%">
                <div class="font1 flex-center">
                  <div
                    class="flexcz"
                    style="justify-content: center; align-items: center"
                  >
                    <span>单人单次</span> <span>用水量</span>
                  </div>
                  <span class="home-title-view view-big"> ：1升/人</span>
                </div>
                <!-- <div class="font1">
                  总计人流量：<span class="home-title-view view-big">
                    {{ toiletTypeDataContrast.vacuumVF }}人</span
                  >
                </div>
                <div class="font1">
                  总用水电量：<span class="home-title-view view-big"
                    >{{ toiletTypeDataContrast.vacuumWater }}吨●{{
                      toiletTypeDataContrast.vacuumElec
                    }}kw</span
                  >
                </div>
                <div class="font1">
                  平均单人碳排放：<span class="home-title-view view-big">
                    {{ vacuumC }}kg</span
                  >
                </div> -->
              </div>
            </div>
            <div
              class="flexcz the_boxshadow k_b1"
              style="width: 36%; height: 100%; padding: 1%; margin: 0 2%"
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <div style="height: 100%; width: 100%; position: relative">
                <div class="position center-balls"></div>
                <div class="position air-balls"></div>
                <div class="position air-ball center-ball"></div>
                <div class="position air-ball0 center-ball0"></div>
                <div
                  class="position air-ball1 center-ball1"
                  style="
                    background: linear-gradient(to bottom, #2b66b6, #031c49);
                  "
                >
                  <ul class="flexcz" style="width: 100%; height: 100%">
                    <li class="flex-center font2" style="font-size: 1.5vw">
                      真空降碳
                    </li>
                    <li
                      class="flex-center"
                      style="width: 100%;font-family: 'nmb'; color:#1AFF00; height: 15%; font-size: 1.3vw"
                    >
                      {{ reduceC }} 吨<span style="margin-left: 10px"
                        >({{
                          vacuumNums[0].createTime | calculateTimeTransition
                        }}天)</span
                      >
                    </li>
                    <li
                      class="flex-center font2"
                      style="font-size: 1.7vw; color: #fffe04"
                    >
                      <span style="font-family: 'nmb'">
                        {{
                          wisdomC == 0
                            ? 0
                            : (((wisdomC - vacuumC) / wisdomC) * 100).toFixed(2)
                        }}
                      </span>
                      %
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="flexcz k_b1 the_boxshadow"
              style="width: 30%; height: 100%; padding: 1%"
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <div style="text-align: right; padding-bottom: 5px; height: 25%">
                <div class="title">智慧厕所能耗</div>
                <span class="english">Wisdom to the toilet</span>
              </div>
              <div class="flex-center" style="height: 75%">
                <div class="font1 flex-center">
                  <span class="home-title-view view-big"> 6升/人：</span>
                  <div
                    class="flexcz"
                    style="justify-content: center; align-items: center"
                  >
                    <span>单人单次</span> <span>用水量</span>
                  </div>
                </div>
                <!-- <div class="font1" style="text-align: right">
                  <span class="home-title-view view-big">
                    {{ toiletTypeDataContrast.wisdomVF }}人</span
                  >：总计人流量
                </div>
                <div class="font1" style="text-align: right">
                  <span class="home-title-view view-big"
                    >{{ toiletTypeDataContrast.wisdomWater }}吨</span
                  >：总计用水量
                </div>
                <div class="font1" style="text-align: right">
                  <span class="home-title-view view-big">{{ wisdomC }}kg</span
                  >：平均单人碳排放
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 25%;
            height: 100%;
            flex-direction: column;
            display: flex;
            justify-content: space-between;
          "
        >
          <div style="height: 39%" class="frame">
            <div style="text-align: left; height: 20%">
              <div class="title">智慧厕所运行数据统计</div>
              <span class="english"
                >Operation data statistics of vacuum toilet</span
              >
            </div>
            <el-tabs
              type="border-card"
              @tab-click="changePage"
              v-model="editableTabsValue"
            >
              <el-tab-pane
                :key="item.id"
                v-for="item in wisdomNums"
                :label="item.name"
              >
                <div class="flex">
                  <div class="operation-col">
                    <p class="home-title">运行天数（天）</p>
                    <div class="operation-col-value home-title-view">
                      {{ item.createTime | calculateTimeTransition }}
                    </div>
                  </div>
                  <div class="operation-col">
                    <p class="home-title">人流量（人）</p>
                    <div class="operation-col-value home-title-view">
                      {{ item.sumPeo || 0 }}
                    </div>
                  </div>
                </div>
                <div class="flex" style="margin-top: 10px">
                  <div class="operation-col">
                    <p class="home-title">用水量（吨）</p>
                    <div class="operation-col-value home-title-view">
                      {{ item.sunWater || 0 }}
                    </div>
                  </div>
                  <div class="operation-col">
                    <p class="home-title">能耗（kw·h）</p>
                    <div class="operation-col-value home-title-view">
                      {{ item.sumEle || 0 }}
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div style="height: 25%; margin: 1.5% 0 2% 0" class="frame">
            <div style="text-align: left; height: 14%">
              <div class="title">厕所投诉建议</div>
            </div>
            <table style="width: 100%; font-size: 20px" class="homeTable">
              <thead style="color: #11e2ff">
                <tr>
                  <th>名称</th>
                  <th>描述</th>
                  <th>时间</th>
                  <th>状态</th>
                </tr>
              </thead>
            </table>
            <list-scroll :list="toiletDataList_complaint"></list-scroll>
          </div>
          <div style="height: 25%; padding-bottom: 1%" class="frame">
            <div style="text-align: left; height: 14%">
              <div class="title">智慧厕所工单</div>
            </div>
            <table style="width: 100%; font-size: 20px" class="homeTable">
              <thead style="color: #11e2ff">
                <tr>
                  <th>名称</th>
                  <th>描述</th>
                  <th>时间</th>
                  <th>状态</th>
                </tr>
              </thead>
            </table>
            <list-scroll :list="toiletDataList"></list-scroll>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="loginbm">
      技术支持： 浙江智慧划云科技有限公司 CopyRight@ 2021
    </div> -->
  </div>
</template>

<script>
import top from "@/components/layout/top.vue";
import iconEffect from "@/components/html/iconEffect.vue";
import flowBar from "@/components/html/flowBar.vue";
import barAndLine from "@/components/html/barAndLine.vue";
import towMap from "@/components/html/towMap.vue";
import listScroll from "@/components/html/listScroll.vue";
export default {
  name: "one",
  components: {
    top,
    iconEffect,
    flowBar,
    barAndLine,
    towMap,
    listScroll
  },
  data() {
    return {
      toiletAir: [
        { nh3: null, h2s: null, temp: null, hum: null, evaluateLevel: null }
      ],
      dialogVisible1: false,
      timer_h: null,
      time2: null,
      vacuumNums: [{ createTime: null }],
      wisdomNums: null,
      toiletOperationData: [],
      editableTabsValue: "0",
      transtions: [],
      toiletTypeStatistics: {
        vacuumNum: null,
        vacuumOrderNum: null,
        wisdomNum: null,
        wisdomOrderNum: null
      },
      toiletTypeDataContrast: {
        vacuumVF: null,
        vacuumWater: null,
        wisdomVF: null,
        wisdomWater: null
      },
      toiletDataList: [],
      toiletDataList_complaint: [],
      data: [],
      loading: false,
      centerDialogVisible: false,
      name: ""
    };
  },
  methods: {
    getAir() {
      //空气质量数据
      this.get("toiletData/listAir", {}).then(res => {
        this.toiletAir = res.data.rows;
      });
    },
    getToiletTypeStatistics() {
      //运维和厕所数量
      this.get("/toiletInfo/toiletTypeStatistics", {}).then(res => {
        this.toiletTypeStatistics = res.data.data;
      });
    },
    getToiletTypeDataContrast() {
      //获取真空碳排放数据
      this.get("/toiletInfo/toiletTypeDataContrast", {}).then(res => {
        this.toiletTypeDataContrast = res.data.data;
      });
    },
    //厕所人流
    getToiletList() {
      //厕所列表
      this.get("toiletInfo/list", {}).then(res => {
        this.toiletOperationData = res.data.rows;
        this.wisdomNums = this.toiletOperationData.filter(function(item) {
          return item.toiletType == 1 || item.toiletType == 2;
        });
        this.vacuumNums = res.data.rows.filter(function(item) {
          return item.toiletType == 2;
        });
        this.transtions = res.data.rows.filter(function(item) {
          return item.toiletType == 3;
        });
      });
    },

    // 获取工单数据
    getAlarmWork() {
      this.get("operation/management/list", {
        pageSize: 20,
        pageNum: 1
      }).then(res => {
        this.toiletDataList = res.data.rows.filter(function(item) {
          return item.alarmType !== 2000;
        });
        this.toiletDataList_complaint = res.data.rows.filter(function(item) {
          return item.alarmType == 2000;
        });
        for (var i = 0; i < this.data.length; i++) {
          if (
            this.toiletDataList[i].status == 0 &&
            this.toiletDataList[i].creator != localStorage.getItem("useId")
          ) {
            this.toiletDataList.splice(i, 1);
          }
        }
      });
    },
    changePage(index) {
      this.$refs.carousel.setActiveItem(index.paneName);
    },
    carouselChange(index) {
      this.editableTabsValue = index + "";
    },
    enterNum(e) {
      this.dialogVisible1 = true;
      this.time2 = e;
    },
    eleaveNum() {
      this.dialogVisible1 = false;
      this.time2 = null;
    }
  },
  computed: {
    reduceC() {
      //固定减碳值
      if (this.toiletTypeDataContrast.vacuumVF > 0) {
        //真空用水
        let a1 = this.toiletTypeDataContrast.vacuumVF;

        //真空碳排放
        let num1 =
          2.48 * (a1 + a1 * 1.3) + 0.7 * this.toiletTypeDataContrast.vacuumElec;
        //传统碳排放
        let num2 = 2.48 * (6 * a1 + (a1 * 1.3 + 5 * a1));
        //减碳值
        var num = (num2 - num1) / 1000;
        return num.toFixed(1);
      } else {
        return 0;
      }
    },
    vacuumC() {
      //真空单人碳排放
      // a1是用水量，a2是用电量
      let a1 = this.toiletTypeDataContrast.vacuumVF;
      let a2 = this.toiletTypeDataContrast.vacuumElec;
      if (a1 > 0) {
        let num = 1.7 * a1 + 0.78 * (1.3 * a1) + 0.7 * a2;
        return num.toFixed(2);
      } else {
        return 0;
      }
    },
    wisdomC() {
      //智慧单人碳排放
      // a1是用水量，b1是节约用水量（与传统用水比）
      let a1 = this.toiletTypeDataContrast.vacuumVF;
      let b1 = a1 * 5;
      //节约的用水量
      if (a1 > 0) {
        let num = 1.7 * b1 + 0.78 * (b1 + 0.3 * a1);
        return num.toFixed(2);
      } else {
        return 0;
      }
    }
  },

  mounted() {
    this.getAir();
    this.getToiletTypeStatistics();
    this.getToiletTypeDataContrast();
    this.getToiletList();
    this.getAlarmWork();
    if (this.timer_h) clearInterval(this.timer_h);
    this.timer_h = setInterval(() => {
      this.getAir();
      this.getToiletTypeStatistics();
      this.getToiletTypeDataContrast();
      this.getAlarmWork();
    }, 60 * 1000);
  },
  //移除事件监听，避免内存泄漏
  beforeDestroy() {
    clearInterval(this.timer_h);
    this.timer_h = null;
  },
  created() {}
};
</script>

<style scoped>
.homePages /deep/ .bagimg {
  height: 100%;
  position: relative;
  width: 100%;
  /* background-image: url(../../img/baseImg/headbackground.png); */
  background-color: #000;
  left: 0;
  border-bottom: 0px solid #ddd;
}

ul {
  margin: 0;
  padding: 0;
}

.toiletIng /deep/ .el-input__inner {
  background: rgb(6, 50, 91);
  border: none;
  color: #fff;
}

.homePages /deep/ p {
  color: #fff;
}

.homeTable td {
  padding: 1% 0;
}

.air-col-8 {
  height: calc(100% - 5px);
  width: calc(50% - 10px);
  position: relative;
}

.positiontop {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
}

.air-col-8 img {
  height: 3vw;
  float: left;
  margin: 0 8% 0 8%;
}

.air-ball {
  width: 11vw;
  height: 11vw;
  border-radius: 50%;
  background-color: #0c5a9c;
  border: solid 2px #00cece;

  z-index: 10;
}

.air-ball1 {
  width: 10vw;
  height: 10vw;
  border-radius: 50%;
  background-color: #041e4f;
  /* box-shadow: rgb(4, 91, 146) 0 0 10px inset; */
  z-index: 12;
}

.air-ball0 {
  width: 10.5vw;
  height: 10.5vw;
  border-radius: 50%;
  background-color: #0c5a9c;
  z-index: 11;
  border: dotted 2px #00dfff;
}

.center-balls {
  width: 12.5vw;
  height: 12.5vw;
  background: linear-gradient(to bottom, #05b3fc, #08ebd7);
  z-index: 8;
  border-radius: 50%;
}

.air-balls {
  width: 11vw;
  height: 11vw;
  border-radius: 50%;
  background-color: #0c5a9c;
  z-index: 9;
}

.center-ball {
  width: 10.5vw;
  height: 10.5vw;
}

.center-ball0 {
  width: 10vw;
  height: 10vw;
}

.center-ball1 {
  width: 9.5vw;
  height: 9.5vw;
}

.loginbm {
  height: 5%;
  line-height: 50px;
  text-align: center;
  background: -webkit-linear-gradient(top, #041e50, #01152f);
  position: absolute;
  bottom: 0;
  width: 100%;
  color: #dadfe2;
  font-weight: bold;
}

.bordertop {
  background: radial-gradient(
      circle at center center,
      rgba(10, 10, 218, 0),
      rgba(10, 10, 218, 0)
    ),
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) left
      top,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) left
      top,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) right
      top,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) right
      top,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) left
      bottom,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) left
      bottom,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) right
      bottom,
    linear-gradient(rgba(179, 224, 255, 0.62), rgba(179, 224, 255, 0.62)) right
      bottom,
    linear-gradient(rgba(56, 144, 184, 0.6), rgba(56, 144, 184, 0.6)) top,
    linear-gradient(rgba(26, 87, 130, 0.6), rgba(26, 87, 130, 0.6)) bottom,
    linear-gradient(
        rgba(56, 144, 184, 0.6),
        rgba(219, 240, 255, 0.8),
        rgba(26, 87, 130, 0.6)
      )
      left,
    linear-gradient(
        rgba(56, 144, 184, 0.6),
        rgba(219, 240, 255, 0.8),
        rgba(26, 87, 130, 0.6)
      )
      right;
  background-repeat: no-repeat;
  background-position: 1px 1px, 0px 0px, 0px 0px, 0px 100%, 0px 100%, 100% 0px,
    100% 0px, 100% 100%, 100% 100%, 0px 0px, 0px 100%, 0px 100%, 100% 100%;
  background-size: calc(100% - 2px) calc(100% - 2px), 1px 10px, 10px 1px,
    1px 10px, 10px 1px, 1px 10px, 10px 1px, 1px 10px, 10px 1px, 100% 1px,
    100% 1px, 1px 100%, 1px 100%;
}

.home-title {
  height: 18%;
  align-items: center;
  justify-content: center;
  font-size: 0.9vw;
}

.home-title-view {
  color: #11e2ff;
  font-family: "nmb";
  font-size: 1.3vw;
}

.frame {
  padding: 3%;
  border-radius: 5px;
  border: 3px solid rgba(5, 29, 79, 1);
  background: -webkit-linear-gradient(top, #041e50, #01152f);
  color: #fff;
}

.row-air {
  height: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.airA {
  color: #1aff00;
}
.airB {
  color: #fffe04;
}
.airC {
  color: #dd3805;
}

.font1 {
  text-align: left;
  font-size: 22px;
  font-family: "nmb";
}

.font2 {
  width: 100%;
  height: 42.5%;
  font-size: 1vw;
}

.view-big {
  font-size: 28px;
}

.titleIng p {
  margin-top: 7px;
  color: #fff;
  text-align: left;
}

.positiontop p {
  color: #fff;
  font-size: 0.9vw;
  font-family: "微软正黑体";
}

.titleIng > div > p {
  font-size: 1.3vw;
}

.flex-start {
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
}

.titleIng > p {
  text-align: center;
  font-size: 1vw;
}

.titleIng div {
  font-size: 1vw;
  font-weight: 600;
}

.title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 5px;
}

.title_color {
  font-size: 1.6vw;
  color: #11e2ff;
  font-family: "nmb";
}
.title_color span {
  font-size: 1.1vw;
}

.english {
  font-size: 15px;
  color: #919fb2;
}

.customer-box {
  border: 1px solid #003a4c;
  padding: 5px;
  width: 45%;
  border-radius: 7px;
}

.customer-box > p {
  text-align: left;
  padding: 5px 0px 10px;
}

.customer-box > div {
  height: 50px;
  font-size: 30px;
  line-height: 50px;
  font-weight: 600;
  border-radius: 7px;
}

.toilet-data {
  text-align: left;
  line-height: 30px;
}

.toilet-data div {
  padding-right: 11px;
}

.general-frame >>> .map-icon-title {
  z-index: 500 !important;
}

.general-frame >>> .el-dialog__title {
  color: white;
}

.general-frame >>> .el-dialog__body {
  color: white;
}

.general-frame >>> .el-dialog {
  background: #001529bb;
}

.general-frame >>> .el-tabs--border-card {
  background: #ffffff00;
  border: 1px solid #003a4c;
}

.general-frame >>> .el-tabs--border-card > .el-tabs__header {
  background-color: #003867;
  border-bottom: 1px solid #003a4c;
  margin: 0;
}

.general-frame
  >>> .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: white;
}

.general-frame
  >>> .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
  color: #ffffff;
  background-color: #339ce1;
  border-right-color: #339ce1;
  border-left-color: #339ce1;
}

.general-frame >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #909399;
}

/*厕所运行数据统计*/
.operation-col {
  height: 47%;
  border: 1px solid #003a4c;
  padding: 5px;
  width: 45%;
  border-radius: 7px;
}

.operation-col > p {
  margin-bottom: 10px;
}

.operation-col-value {
  background-color: #003a4c;
  font-size: 4vh;
  border-radius: 4px;
  justify-content: center;
}
.wisdomNum:hover,
.vacuumNum:hover,
.tradition:hover {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: #11e2ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue